export const h = {
  stat:{
    zcrs:"Number of registrations",
    scrs:"Number of first charge users",
    scje:"Initial deposit amount",
    yhkbs:"Number of bank card transactions",
    yhkrj:"Bank card deposit",
    usdtbs:"Number of USDT transactions",
    usdtrj:"USDT deposit",
    cjbs:"Number of gold withdrawal transactions",
    cjje:"Withdrawal amount",
    tdzrs:"Total number of team members"
  },
	login:{
			login:"Log in",
			pleaseusername:"please enter user name",
			pleasepassword:"Please enter password",
			checkname:"Please enter correct username",
			checkpass:"Password cannot be less than 3 characters",
		},
	navbar:{
		home:"front page",
		mycenter:"Personal Center",
		outlogin:"quit",
		close:"closure",
		editLanguage:"Editing language",
	},
	vip:{
    ywy:"salesman",
		nickname:"Nick name",
		pleasenickname:"Please enter a nickname",
		username:"username",
		pleaseusername:"please enter user name",
		arealogin:"Login area",
		pleasearealogin:"Please enter your login region",
		nationality:"Country of Citizenship",
		pleasenationality:"Please select your nationality",
		depositstatus:"Deposit Status",
		pleasedepositstatus:"Please select the deposit status",
		createtime:"Creation time",
		logintime:"Log in time",
		startime:"Starting time",
		endtime:"End Time",
		no:"serial number",
		shangji:"Directly promote superiors",
		keyongmoney:"Available Balance",
		baozhengjing:"Margin",
		fudongyingkui:"Floating profit and loss",
		zicantotal:"Total assets",
		yaoqingma:"Invitation code",
		zongrujing:"Total deposit",
		zongchujing:"Total withdrawal",
		loginIp:"Login IP",
		zuihoulogin:"last login time",
		shoucirujingmoney:"First deposit amount",
		shoucirujingtime:"First deposit time",
		kaitongtime:"Opening time",
		keyong:"Available",
		daoshi:"tutor",
		dongjie:"freeze",
		chujingstate:"Withdrawal Status",
		xiajichujingstate:"Subordinate withdrawal status",
		caozuo:"operate",
		chakan:"Check",
		heji:"total",
		moneytotal:"Total balance",
		paixu:"Sorting",
		daochu:"Export",
		huiyuanguanli:"Membership Management",
		yonghu:"user",
		search:"Query Search",
		reset:"Reset",
		delete:"delete",
		kickout:"Kick Out",
		notlogin:"Not logged in",
		editLanguage:"Editing language",
		yourujing:"With deposit",
		wurujing:"No deposit",
    todayreg: "Today's registration volume: ",
    newvipnum: "The number of new VIP members joining: ",
    juese: "role",
    xiugaimima: "change password",
    jiumima: "old password",
    shurujiumima: "please enter old password",
    xinmima: "new password",
    shuruxinmima: "please enter new password",
    gerenzhongxing: "personal center",
    yonghuxinxi: "user information",
    remark: "Remark"
	},
	info:{
		home:"Home",
		user:"user ID",
		nickname:"Nick name",
		account:"account",
		identity:"ID number",
		phone:"phone number",
		nationality:"Country of Citizenship",
		Balance:"Balance Management",
		real:"real account",
		zhongmongy:"Total balance",
		keyongmoney:"Available Balance",
		jiaoyidongjie:"Transaction frozen",
		shishilirun:"real time profit",
		shishikeyong:"Available in real time",
		xunizhanghu:"virtual account",
		churujinguanli:"Deposit and withdrawal management",
		chakanzijinjilu:"View fund history",
		rujinjilu:"Deposit record",
		rujinjine:"Deposit amount",
		jiaoyibishu:"Number of transactions",
		chujinjilu:"Withdrawal records",
		chujinjine:"Withdrawal amount",
		jiaoyiguanli:"Transaction management",
		lishijilu:"history record",
		chakanlishi:"View historical transaction information",
		jiaoyishoushu:"Trading lots",
		jiaoyiyingkui:"Trading profit and loss",
		dangqianchicang:"Current position",
		chakandangqianchicang:"View current position information",
		dangqianguadan:"Current pending order",
		chakanguadanliebiao:"View pending order list",
		guadanbishu:"Number of pending orders",
		yongjinguanli:"Commission management",
		duanwei:"rank",
		wu:"none",
		zhishushangji:"Immediate superior",
		shangjidaili:"Superior agent",
		xiajituandui:"Subordinate team",
		shurudailiname:"Please enter agent name",
		chakan:"Check",
		fanyongjie:"Rebate amount",
		fanyongbishu:"Number of rebates",
		chakanyongjinjilu:"View rebate records",
		chakanyonghuinfo:"View user details",
		chakanwenjuan:"View questionnaire",
		resetpassword:"reset Password",
    resetjypassword:"reset Transaction Password",
		sendmsg:"send Message",
		update:"Revise",
		unbound:"Not bound",
		weishiming:"N",
		yishiming:"Y",
		shiming:"realname",
		gendan:"Documentation management",
		gensui:"follow",
		chakangendan:"View order records",
		dingdanhao:"order number",
		shoudongpay:"Manual recharge",
		chakanyongjingjilu:"View commission history",
		xiugaiyonghuxinxi:"Modify user information",
		queding:"Sure",
		quxiao:"Cancel",
		email:"Mail",
		selguoji:"Please select your nationality",
		sendusermsg:"Send message to user",
		title:"title",
		shurutitle:"Please enter a message title",
		content:"content",
		shurucontent:"Please enter the message content",
		zhenshi:"reality",
		xuni:"virtual",
		fangxiang:"direction",
		zhanghu:"Account",
		add:"Increase",
		less:"deduct",
		type:"type",
		guanliyuanpay:"Administrator recharge",
		pay:"top up",
		money:"Amount",
		updategdmsg:"Modify order information",
		xinhaoyuan:"signal source",
		yes:"yes",
		no:"no",
		updateyongjingmsg:"Modify commission information",
		qingxuanzejuese:"Please select your account role",
		zuoduo:"Long",
		zuokong:"Short",
		gensuinicheng:"Follow Nickname",
		kaicangjia:"Opening price",
		pingcangjia:"Closing price",
		shousu:"Lots",
		pingcangdate:"Opening date",
		kaicangdate:"Closing date",
		chakangensuiinfo:"View follow details",
		gensuiuserno:"Follow User ID",
		gensuiyonghuname:"Follow User Nickname",
		gensuifangshji:"Follow",
		number:"quantity",
		danwei:"unit",
		zhengxiang:"Positive",
		fanxaing:"Reverse",
		beishu:"multiple",
		shousu:"Lots",
		gensuizhuangtai:"Follow Status",
		genjinzhong:"Applying for follow-up",
		gensuiok:"Agreed to be followed",
		gensuino:"Refused to be followed",
		chexiao:"Revocation",
		gensuidate:"Follow time",
		chakanlishijiaoyi:"View historical transaction information",
		chakanguadanlist:"View pending order list",
		heyue:"contract",
		daili:"acting",
		huiyuanname:"Member's name",
		xianjia:"Limit Price",
		zhisun:"Stop Loss",
		guadanjia:"Order Price",
		zhiyingzhisun:"Take Profit and Stop Loss",
		zhiyingjia:"Take Profit Price",
		zhiyinghuichejia:"Take Profit Retracement Price",
		zhisunjia:"Stop Loss Price",
		zhisunhuichejia:"Stop Loss Retracement Price",
		weiset:"Not set",
		zt:"state",
		chakanchicangmsg:"View current position information",
		shouyiId:"Beneficiary ID",
		xiajiid:"Subordinate User ID",
		xiajiuser:"Subordinate Username",
		fanyongmonney:"Rebate amount",
		tuihuibaozhengjing:"Return of deposit",
		shouxufei:"handling fee",
		shouyi:"income",
		lixi:"Interest",
		zengmoney:"bonus",
		zhuijiabaozhengjing:"margin call",
		fanyong:"Rebate",
		rujing:"Deposit",
		chujing:"Withdraw funds",
		chujingshibai:"Refund if withdrawal review fails",
		guanliyuanless:"Admin deduction",
		pingzhong:"Variety",
		shengqingzhong:"Applying",
		wancheng:"Finish",
    jujue:"reject",
		chongzhimima:"Password reset successful",
		copy:"copy",
		zhanghaomima:"account password",
		fenye:"Article / Page",
    tixianmima:"Withdrawal password",
		gong:"common",
		tiao:"strip",
		ye:"Page",
		goto:"Go to",
		outtitle:"You have been logged out. You can cancel and stay on this page or log in again.",
		outok:"OK to log out",
		chongxingdenglu:"re-register",
		cancel:"Cancel",
		pingtai:"platform",
		nodata:"No data",
    shangjiID: "Superior ID",
    shangjiaccount: "Superior Account",
    shangjiname: "Superior Nickname",
    shangjinickname: "Superior Name",
    zhongyingkui: "Total Profit and Loss",
    fuying: "Floating Profit",
    yue: "Balance",
    sheng: "Ascending Order",
    jiang: "Descending Order",
    dongjie:"Your account has been frozen",
    jiedong:"Account has been unfrozen"
	},
	history:{
			yingkui:"Profit and loss",
			guadan:"pending order",
			shijia:"market price",
			gendan:"Follow orders",
			dangqianjia:"current price",
			geyelixi:"overnight interest",
			weituodate:"Commission time",
			pingcangfangshi:"Closing method",
			dingdanyongjing:"Order commission",
			shoudongpingcang:"Manual closing",
			qiangzhipingcang:"Forced liquidation",
			gendanpingcang:"Follow orders to close a position",
			baocang:"Liquidation",
			yuguqiangpingjia:"Estimated forced parity price",
			kaicangdiqu:"Opening area",
			ispingcang:"Are you sure about forced liquidation?",
			tips:"hint",
			pincangsucc:"Position closed successfully",
			queding:"Sure",
			cancel:"Cancel",
		},

	Langswitch: {
	  "en":"English",
	  "id":"Indonesian",
	  "th":"Thai Language",
	  "vi":"Vietnamese",
	  "zh":"Chinese",
	  "fa":"French",
	  "han":"Korean",
	  "tu":"turkish",
	  "pu":"Portuguese",
	  "xi":"spanish",
	  "jp":"Japanese",
	  "ar":"Arabic",
	},
}



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js